const buildBundle = () => {
  window.hasSubscription = false;
  const selectCover = () => {
    const selectCover = $('.option-select .sub-normal')
    const selectCoverChildren = selectCover.find('.select-cover')

    selectCover.click(function (e) {
      if (!selectCoverChildren.is(e.target) && selectCoverChildren.has(e.target).length === 0) {
        selectCover.addClass('active-sub')
      }
    })

    selectCoverChildren.click(function () {
      selectCover.removeClass('active-sub')
    })

    $('body').click(function (e) {
      if (!selectCover.is(e.target) && selectCover.has(e.target).length === 0) {
        selectCover.removeClass('active-sub')
      }
    })

    const selectCovers = $('.select-cover-option')
    selectCovers.each(function () {
      const self = $(this)
      const selectCover = self.children('.select-cover')
      selectCover.click(function (e) {
        if($(this).hasClass('one-time')){
          window.hasSubscription = false;
          $('.estimated-total').text($('.final.variant-origin-price').eq(0).text())
          if($(this).closest('.section-bundle-setting').length > 0){
            $('.bundle-floating-bottom .select-cover.sub-normal.subscription').removeClass('active');
            $('.bundle-floating-bottom .select-cover.one-time').addClass('active');
          }else{
            $('.section-bundle-setting .select-cover.sub-normal.subscription').removeClass('active');
            $('.section-bundle-setting .select-cover.one-time').addClass('active');
          }
        }
        if($(this).hasClass('subscription')){
          window.hasSubscription = true;
          $('.section-bundle-setting .estimated-total').text($('.section-bundle-setting .price-per-pack-subscription').eq(0).text())
          if($(this).closest('.section-bundle-setting').length > 0){
            $('.bundle-floating-bottom .select-cover.sub-normal.subscription').addClass('active');
            $('.bundle-floating-bottom .select-cover.one-time').removeClass('active');
          }else{
            $('.section-bundle-setting .select-cover.sub-normal.subscription').addClass('active');
            $('.section-bundle-setting .select-cover.one-time').removeClass('active');
          }
        }
        
        if ($(this).hasClass('sub-normal') && $(this).hasClass('active')) {
          return
        }

        selectCover.removeClass('active')
        if (selectCover.hasClass('sub-normal') && !selectCover.hasClass('active')) {
          selectCover.find('.multi-sub').slideUp()
        }

        $(this).addClass('active')
        if($(this).hasClass('bundle-size')){
          var packs = parseInt($(this).attr('data-pack'));
          if(packs == 3){
            var variant = window.product.variants[0];
            $('.desc-need').show();
          }else if(packs == 6){
            var variant = window.product.variants[1];
            $('.desc-need').hide();
          }else if(packs == 8){
            var variant = window.product.variants[2];
            $('.desc-need').hide();
          }else if(packs == 12){
            var variant = window.product.variants[3];
            $('.desc-need').hide();
          }
          $('.bundle-floating-bottom .select-cover.bundle-size').removeClass('active')
          $('.bundle-floating-bottom .select-cover.bundle-size[data-pack="'+packs+'"]').addClass('active')
          $('.section-bundle-setting .select-cover.bundle-size').removeClass('active')
          $('.section-bundle-setting .select-cover.bundle-size[data-pack="'+packs+'"]').addClass('active')
          window.selected_variant = variant;
          $('.variant-origin-price.final').text(Shopify.formatMoney(variant.price,Shopify.money_format));
          $('.variant-origin-price.monthly').text(Shopify.formatMoney(variant.price,Shopify.money_format));
          $('.variant-origin-price.3-months').text(Shopify.formatMoney(variant.price * 3,Shopify.money_format));
          $('.variant-origin-price.6-months').text(Shopify.formatMoney(variant.price * 6,Shopify.money_format));
          $('.variant-origin-price.12-months').text(Shopify.formatMoney(variant.price * 12,Shopify.money_format));
          $('.monthly-subscription').text(Shopify.formatMoney(variant.monthly_subscription,Shopify.money_format));
          $('.monthly-per-pack').text(Shopify.formatMoney(variant.monthly_subscription,Shopify.money_format));
          $('.3-months-subscription').text(Shopify.formatMoney(variant._3_monthly_subscription * 3,Shopify.money_format));
          $('.3-months-per-pack').text(Shopify.formatMoney(variant._3_monthly_subscription,Shopify.money_format));
          $('.6-months-subscription').text(Shopify.formatMoney(variant._6_monthly_subscription * 6,Shopify.money_format));
          $('.6-months-per-pack').text(Shopify.formatMoney(variant._6_monthly_subscription,Shopify.money_format));
          $('.12-months-subscription').text(Shopify.formatMoney(variant._12_monthly_subscription * 12,Shopify.money_format));
          $('.12-months-per-pack').text(Shopify.formatMoney(variant._12_monthly_subscription,Shopify.money_format));
          $('.section-bundle-setting .bundle-right .choose-bundle .choose-bundle-in .title-flex h3').text(Shopify.formatMoney(variant.price,Shopify.money_format));
          $('.bundle-floating-bottom .title-flex h3').text(Shopify.formatMoney(variant.price,Shopify.money_format));
          $('.origin.origin-per-pack').text(Shopify.formatMoney(variant.price,Shopify.money_format));
          if($('.select-cover.active[data-subscription]').attr('selling-index') == '1'){
            $('.price-per-pack-subscription').text(Shopify.formatMoney(variant[window.selected_subscription] * 3,Shopify.money_format));
            $('.origin.price-per-pack').text(Shopify.formatMoney(variant.price * 3,Shopify.money_format));
          }else if($('.select-cover.active[data-subscription]').attr('selling-index') == '2'){
            $('.price-per-pack-subscription').text(Shopify.formatMoney(variant[window.selected_subscription] * 6,Shopify.money_format));
            $('.origin.price-per-pack').text(Shopify.formatMoney(variant.price * 6,Shopify.money_format));
          }else if($('.select-cover.active[data-subscription]').attr('selling-index') == '3'){
            $('.price-per-pack-subscription').text(Shopify.formatMoney(variant[window.selected_subscription] * 12,Shopify.money_format));
            $('.origin.price-per-pack').text(Shopify.formatMoney(variant.price * 12,Shopify.money_format));
          }else{
            $('.price-per-pack-subscription').text(Shopify.formatMoney(variant[window.selected_subscription],Shopify.money_format));
            $('.origin.price-per-pack').text(Shopify.formatMoney(variant.price,Shopify.money_format));
          }
          if(window.hasSubscription){
            $('.section-bundle-setting .estimated-total').text($('.final.price-per-pack-subscription').eq(0).text())
            $('.bundle-floating-bottom .estimated-total').text($('.final.price-per-pack-subscription').eq(0).text())
          }else{
            $('.section-bundle-setting .estimated-total').text($('.final.variant-origin-price').eq(0).text())
            $('.bundle-floating-bottom .estimated-total').text($('.final.variant-origin-price').eq(0).text())
          }
          if (packs >= 6) {
            $('.splide-promo-bundle').show();
            $('.splide-promo-bundle-2').hide();
            $('.splide-promo-bundle-sp').show();
          } else {
            $('.splide-promo-bundle').hide();
            $('.splide-promo-bundle-2').show();
            $('.splide-promo-bundle-sp').hide();
          }
          var listItems = $('.section-bundle-setting .list-selected .selected-item');
          if (packs > listItems.length) {
            for (let i = listItems.length; i < packs; i++) {
              $('.section-bundle-setting .list-selected').append('<div class="selected-item"></div>')
              $('.bundle-floating-bottom .top-content .list-selected').append('<div class="selected-item"></div>')
              $('.bundle-floating-bottom .bottom-content .list-selected').append('<div class="selected-item"></div>')
            }
            $('.btn.random').removeClass('disabled');
            $('.addToBundle').removeAttr('data-tippy-content');
            $('.checkout-button').hide()
          } else {
            for (let i = listItems.length; i > packs; i--) {
              $('.section-bundle-setting .list-selected .selected-item')[i - 1].remove();
              $('.bundle-floating-bottom .top-content .list-selected .selected-item')[i - 1].remove();
              $('.bundle-floating-bottom .bottom-content .list-selected .selected-item')[i - 1].remove();
            }
          }
          randomPacks()
          updateButton()
          updateSelectedQuantity()
        }
        if ($(this).hasClass('sub-normal')) {
          $(this).find('.multi-sub').slideDown()
        }
      })
    })
  }

  const spilePromoBundle = () => {
    const options = {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      gap: '60px',
      autoWidth: true,
      arrows: false,
      pagination: false,
      perPage: 'auto',
      autoScroll: {
        speed: 0.5,
      },
    }

    const splide = new Splide('.splide-promo-bundle', options)
    const splide2 = new Splide('.splide-promo-bundle-2', options)
    splide.mount(window.splide.Extensions)
    splide2.mount(window.splide.Extensions)

    const splideSp = new Splide('.splide-promo-bundle-sp', options)
    splideSp.mount(window.splide.Extensions)
  }

  const movePack = () => {
    const packElement = document.querySelector('.pack');

    gsap.from(packElement, {y: 150})
    gsap.to(packElement, {
      y: 0,
      duration: 1,
      scrollTrigger: {
        trigger: packElement,
        start: "top bottom",
        end: "60% 70%",
        scrub: true,
      }
    });
    $('.btn.random').removeClass('disabled');
    $('.addToBundle').removeAttr('data-tippy-content');
  }

  const summary = () => {
    const btnSummary = $('.btn-summary')
    const bundleFloating = $('.bundle-floating-bottom')
    btnSummary.click(function () {
      $('.top-content').fadeToggle('fast').css('display', 'flex')
      bundleFloating.toggleClass('show')
      $('body').toggleClass('overflow-hidden')

      if (bundleFloating.hasClass('show')) {
        $(this).find('p').text('CHANGE FLAVORS')
      } else {
        $(this).find('p').text('BOX SUMMARY')
      }
    })
  }

  const addBundle = () => {
    const item = $('.bundle-item')

    item.each(function () {
      const self = $(this)
      const btnAdd = $(this).find('.btn-black')
      const amount = self.find('.change-amount .amount')
      const id = self.attr('data-id');
      const name = self.attr('data-name');
      const image = self.attr('data-image');
      const price = self.attr('data-price');

      btnAdd.click(function () {
        if ($('.section-bundle-setting .selected-item:not(:has(.icon-trash))').length > 0) {
          self.addClass('active')
          amount.text('1');
        }
        appendItem($('.section-bundle-setting .selected-item:not(:has(.icon-trash))').eq(0), id, image, name, price, true);
        appendItem($('.bundle-floating-bottom .top-content .selected-item:not(:has(.icon-trash))').eq(0), id, image, name, price, false);
        appendItem($('.bundle-floating-bottom .bottom-content .selected-item:not(:has(.icon-trash))').eq(0), id, image, name, price, false);
      })

      self.find('.change-amount .minus').click(function () {
        if (parseInt(amount.text()) <= 1) {
          self.removeClass('active')
        }
        $('.section-bundle-setting .list-selected .selected-item[data-id="' + id + '"]').last().html('')
        $('.section-bundle-setting .list-selected .selected-item[data-id="' + id + '"]').last().removeAttr('data-id');
        $('.bundle-floating-bottom .list-selected .selected-item[data-id="' + id + '"]').last().html('')
        $('.bundle-floating-bottom .list-selected .selected-item[data-id="' + id + '"]').last().removeAttr('data-id');
        updateButton()
        $('.pick-button').show();
        $('.checkout-button').hide();
        $('.btn.random').removeClass('disabled')
        $('.addToBundle').removeAttr('data-tippy-content');
      })
      self.find('.change-amount .plus').click(function () {
        if ($('.section-bundle-setting .selected-item:not(:has(.icon-trash))').length > 0) {
          let qty = parseInt(amount.text()) + 1;
          amount.text(qty)
          appendItem($('.section-bundle-setting .selected-item:not(:has(.icon-trash))').eq(0), id, image, name, price, true);
          appendItem($('.bundle-floating-bottom .top-content .selected-item:not(:has(.icon-trash))').eq(0), id, image, name, price, false);
          appendItem($('.bundle-floating-bottom .bottom-content .selected-item:not(:has(.icon-trash))').eq(0), id, image, name, price, false);
          if ($('.section-bundle-setting .selected-item:not(:has(.icon-trash))').length == 0)$('.btn.random').addClass('disabled');
        }else{
          $('.btn.random').addClass('disabled');
          $('.addToBundle').attr('data-tippy-content','Your pack is full');
          tippy('[data-tippy-content]')
        }
      })
    })
    const changeAmounts = $('.section-bundle-setting .change-amount')
    changeAmounts.each(function () {
      const changeAmount = $(this)
      const amount = $(this).find('.amount')

      const minus = changeAmount.find('.minus')
      minus.click(function () {
        if (parseInt(amount.text()) <= 1) {
          amount.text(0)
        } else {
          let qty = parseInt(amount.text()) - 1;
          amount.text(qty)
        }
      })
    })
  }

  const selectMulti = () => {
    // if (window.innerWidth < 1366) {
    //   return
    // }

    const options = $('.cover-parent.sub-normal .multi-sub .select-cover')
    const selected = $('.cover-parent.sub-normal .multi:first')
    const text = selected.find('.select-title .text h5')
    const origin = selected.find('.amount .origin')
    const final = selected.find('.amount .final')

    options.click(function () {
      const subscription = $(this).attr('data-subscription')
      const subscription_index = $(this).attr('selling-index')
      const option = $(this).find('.multi')
      const textOption = option.find('.select-title .text h5')
      const originOption = option.find('.select-title .origin')
      const finalOption = option.find('.select-title .final')
      window.selected_subscription = subscription;
      window.selling_plan_index = subscription_index;

      // text.text(textOption.text())
      origin.text(originOption.text())
      final.text(finalOption.text())
      if($(this).closest('.bundle-floating-bottom').length > 0){
        $('.section-bundle-setting .select-cover[data-subscription][selling-index]').removeClass('active')
        $('.section-bundle-setting .select-cover[data-subscription="'+subscription+'"][selling-index="'+subscription_index+'"]').addClass('active')
      }else{
        $('.bundle-floating-bottom .select-cover[data-subscription][selling-index]').removeClass('active')
        $('.bundle-floating-bottom .select-cover[data-subscription="'+subscription+'"][selling-index="'+subscription_index+'"]').addClass('active')
      }
      // $('.subscription-name').text(textOption.text())
      $('.bundle-floating-bottom .origin.price-per-pack').text(originOption.text())
      $('.bundle-floating-bottom .final.price-per-pack-subscription').text(finalOption.text())
      $('.bundle-floating-bottom .estimated-total').text(finalOption.text())
      if(subscription_index == "0"){
        $('.select-cover.sub-normal.subscription > .border-gradient > .multi > .amount > .times').text('Monthly')
      }else if(subscription_index == "1"){
        $('.select-cover.sub-normal.subscription > .border-gradient > .multi > .amount > .times').text('3 months')
      }else if(subscription_index == "2"){
        $('.select-cover.sub-normal.subscription > .border-gradient > .multi > .amount > .times').text('6 months')
      }else if(subscription_index == "3"){
        $('.select-cover.sub-normal.subscription > .border-gradient > .multi > .amount > .times').text('12 months')
      }
    })
  }

  const appendItem = (ele, id, image, name, price, useName = true) => {
    ele.attr('data-id', id)
    ele.attr('data-price', price)
    ele.append(`
    <div class="icon-trash" onclick="window.removeBundleItem(this)">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.3008 3.59961H2.70078C2.46209 3.59961 2.23317 3.69443 2.06439 3.86321C1.8956 4.032 1.80078 4.26091 1.80078 4.49961C1.80078 4.7383 1.8956 4.96722 2.06439 5.13601C2.23317 5.30479 2.46209 5.39961 2.70078 5.39961V14.0315C2.70173 14.8449 3.02529 15.6248 3.60046 16.1999C4.17563 16.7751 4.95546 17.0987 5.76888 17.0996H12.2327C13.0461 17.0987 13.8259 16.7751 14.4011 16.1999C14.9763 15.6248 15.2998 14.8449 15.3008 14.0315V5.39961C15.5395 5.39961 15.7684 5.30479 15.9372 5.13601C16.106 4.96722 16.2008 4.7383 16.2008 4.49961C16.2008 4.26091 16.106 4.032 15.9372 3.86321C15.7684 3.69443 15.5395 3.59961 15.3008 3.59961ZM13.5008 14.0315C13.5005 14.3678 13.3669 14.6902 13.1291 14.9279C12.8913 15.1657 12.5689 15.2994 12.2327 15.2996H5.76888C5.43263 15.2994 5.11023 15.1657 4.87246 14.9279C4.6347 14.6902 4.50102 14.3678 4.50078 14.0315V5.39961H13.5008V14.0315Z" fill="white"></path>
        <path d="M7.20078 2.70039H10.8008C11.0395 2.70039 11.2684 2.60557 11.4372 2.43679C11.606 2.268 11.7008 2.03909 11.7008 1.80039C11.7008 1.5617 11.606 1.33278 11.4372 1.16399C11.2684 0.995212 11.0395 0.900391 10.8008 0.900391H7.20078C6.96209 0.900391 6.73317 0.995212 6.56439 1.16399C6.3956 1.33278 6.30078 1.5617 6.30078 1.80039C6.30078 2.03909 6.3956 2.268 6.56439 2.43679C6.73317 2.60557 6.96209 2.70039 7.20078 2.70039Z" fill="white"></path>
        <path d="M7.20078 12.5996C7.43948 12.5996 7.66839 12.5048 7.83718 12.336C8.00596 12.1672 8.10078 11.9383 8.10078 11.6996V8.99961C8.10078 8.76091 8.00596 8.532 7.83718 8.36321C7.66839 8.19443 7.43948 8.09961 7.20078 8.09961C6.96209 8.09961 6.73317 8.19443 6.56439 8.36321C6.3956 8.532 6.30078 8.76091 6.30078 8.99961V11.6996C6.30078 11.9383 6.3956 12.1672 6.56439 12.336C6.73317 12.5048 6.96209 12.5996 7.20078 12.5996Z" fill="white"></path>
        <path d="M10.8023 12.5996C11.041 12.5996 11.27 12.5048 11.4387 12.336C11.6075 12.1672 11.7023 11.9383 11.7023 11.6996V8.99961C11.7023 8.76091 11.6075 8.532 11.4387 8.36321C11.27 8.19443 11.041 8.09961 10.8023 8.09961C10.5636 8.09961 10.3347 8.19443 10.1659 8.36321C9.99717 8.532 9.90234 8.76091 9.90234 8.99961V11.6996C9.90234 11.9383 9.99717 12.1672 10.1659 12.336C10.3347 12.5048 10.5636 12.5996 10.8023 12.5996Z" fill="white"></path>
      </svg>
    </div>
    <img class="image" src="${image}" alt="Sour Tooth">
    ${useName ? `<p>${name}</p>` : ''}
  `)
    updateButton()
  }

  window.removeBundleItem = (e) => {
    const id = $(e).parent().attr('data-id');
    const parent = $(e).parent();
    if ($(e).closest('.section-bundle-setting').length) {
      var index = $('.section-bundle-setting .list-selected .selected-item').index(parent);
      $('.bundle-floating-bottom .top-content .list-selected .selected-item').get(index).remove();
      $('.bundle-floating-bottom .bottom-content .list-selected .selected-item').get(index).remove();
    } else if ($(e).closest('.top-content').length) {
      var index = $('.bundle-floating-bottom .top-content .list-selected .selected-item').index(parent);
      $('.section-bundle-setting .list-selected .selected-item').get(index).remove();
      $('.bundle-floating-bottom .bottom-content .list-selected .selected-item').get(index).remove();
    } else {
      var index = $('.bundle-floating-bottom .bottom-content .list-selected .selected-item').index(parent);
      $('.section-bundle-setting .list-selected .selected-item').get(index).remove();
      $('.bundle-floating-bottom .top-content .list-selected .selected-item').get(index).remove();
    }
    $(e).parent().remove();
    $('.list-selected').append('<div class="selected-item"></div>');
    let new_qty = parseInt($('.section-bundle-setting .bundle-item[data-id="' + id + '"] .amount').text()) - 1;
    if (new_qty >= 0) {
      $('.section-bundle-setting .bundle-item[data-id="' + id + '"] .amount').text(new_qty);
      if (new_qty == 0) {
        $('.section-bundle-setting .bundle-item[data-id="' + id + '"]').removeClass('active')
      }
    }
    updateButton()
    $('.pick-button').show();
    $('.checkout-button').hide();
    $('.btn.random').removeClass('disabled')
    $('.addToBundle').removeAttr('data-tippy-content');
  }
  const updateButton = () => {
    // var total = 0;
    // $('.section-bundle-setting .selected-item:has(.icon-trash)').each((i, item) => {
    //   total += parseInt($(item).attr('data-price'));
    // })
    // $('.section-bundle-setting .bundle-right .choose-bundle .choose-bundle-in .title-flex h3').text(Shopify.formatMoney(total, Shopify.money_format))
    // $('.bundle-floating-bottom .title-flex h3').text(Shopify.formatMoney(total, Shopify.money_format))
    var missingItemsCount = $('.section-bundle-setting .selected-item:not(:has(.icon-trash))').length;
    switch (missingItemsCount) {
      case 0:
        $('.btn.pick-more .txt p').text(`Done`);
        $('.section-bundle-setting .pick-button').hide();
        $('.checkout-button-list.full').hide();
        $('.checkout-button').show();
        $('.checkout-button-list:not(.full)').show();
        break;
      case 1:
        $('.btn.pick-more .txt p').text(`PICK ONE MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 2:
        $('.btn.pick-more .txt p').text(`PICK TWO MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 3:
        $('.btn.pick-more .txt p').text(`PICK THREE MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 4:
        $('.btn.pick-more .txt p').text(`PICK FOUR MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 5:
        $('.btn.pick-more .txt p').text(`PICK FIVE MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 6:
        $('.btn.pick-more .txt p').text(`PICK SIX MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 7:
        $('.btn.pick-more .txt p').text(`PICK SEVEL MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 8:
        $('.btn.pick-more .txt p').text(`PICK EIGHT MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 9:
        $('.btn.pick-more .txt p').text(`PICK NINE MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 10:
        $('.btn.pick-more .txt p').text(`PICK TEN MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 11:
        $('.btn.pick-more .txt p').text(`PICK ELEVEN MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
      case 12:
        $('.btn.pick-more .txt p').text(`PICK TWELVE MORE BAG(S)`);
        $('.section-bundle-setting .pick-button').show();
        $('.checkout-button-list.full').show();
        $('.checkout-button-list:not(.full)').hide();
        break;
    }
  }
  const pickMore = () => {
    $('.pick-more').click(() => {
      $('.list-bundle-item').get(0).scrollIntoView({ behavior: 'smooth' });
    })
  }
  const getRndInteger = (min, max) => {
    return Math.floor(Math.random() * (max - min)) + min;
  }
  const randomPacks = () => {
    $('.btn.random').click(() => {
      if ($('.section-bundle-setting .selected-item:not(:has(.icon-trash))').length == 0) {
        $('.section-bundle-setting .selected-item').each((i, ele) => {
          let index = getRndInteger(0, $('.list-bundle-item .bundle-item.available').length);
          let pack = $('.list-bundle-item .bundle-item.available').get(index);
          let id = $(pack).attr('data-id');
          let name = $(pack).attr('data-name');
          let image = $(pack).attr('data-image');
          let price = $(pack).attr('data-price');
          $('.section-bundle-setting .selected-item').eq(i).html('')
          $('.bundle-floating-bottom .top-content .selected-item').eq(i).html('')
          $('.bundle-floating-bottom .bottom-content .selected-item').eq(i).html('')
          appendItem($('.section-bundle-setting .selected-item').eq(i), id, image, name, price, true);
          appendItem($('.bundle-floating-bottom .top-content .selected-item').eq(i), id, image, name, price, false);
          appendItem($('.bundle-floating-bottom .bottom-content .selected-item').eq(i), id, image, name, price, false);
        })
      }else{
        $('.section-bundle-setting .selected-item').each((i, ele) => {
          if(!$(ele).is(':has(.icon-trash)')){
            let index = getRndInteger(0, $('.list-bundle-item .bundle-item.available').length);
            let pack = $('.list-bundle-item .bundle-item.available').get(index);
            let id = $(pack).attr('data-id');
            let name = $(pack).attr('data-name');
            let image = $(pack).attr('data-image');
            let price = $(pack).attr('data-price');
            appendItem($('.section-bundle-setting .selected-item').eq(i), id, image, name, price, true);
            appendItem($('.bundle-floating-bottom .top-content .selected-item').eq(i), id, image, name, price, false);
            appendItem($('.bundle-floating-bottom .bottom-content .selected-item').eq(i), id, image, name, price, false);
          }
        })
      }
      updateSelectedQuantity()
      $('.btn.random').addClass('disabled');
      $('.addToBundle').attr('data-tippy-content','Your pack is full');
      tippy('[data-tippy-content]');
      updateButton()
    })
  }

  const updateSelectedQuantity = () => {
    var selected_packs = {};
    $('.section-bundle-setting .selected-item').each((i,item) => {
      var id = $(item).attr('data-id');
      if(selected_packs[id] != undefined){
        selected_packs[id] = selected_packs[id] + 1;
      }else{
        selected_packs[id] = 1
      }
    })
    $('.bundle-item').removeClass('active');
    Object.entries(selected_packs).forEach(pack => {
      $('.bundle-item[data-id="'+pack[0]+'"]').addClass('active')
      $('.bundle-item[data-id="'+pack[0]+'"] .amount').text(pack[1])
    })
  }

  const addToCart = () => {
    $('.addToCart').click(() => {
      addCart('/cart')
    })
    $('.buyNow').click(() => {
      addCart('/checkout')
    })
    const addCart = (url) => {
      var flavors = [];
      $('.section-bundle-setting .list-selected .selected-item').each((i, item) => {
        let name = $(item).find('p').text();
        let index = flavors.findIndex(f => f.name == name)
        if(index != -1){
          flavors[index].qty += 1;
        }else{
          flavors.push({
            name,
            qty: 1
          })
        }
      })
      var props = '';
      flavors.forEach(fla => {
        props += `,${fla.qty} x ${fla.name}`
      })
      var items = [{
        id: window.selected_variant.id,
        quantity: 1,
        properties: {
          'Flavors': props.replace(',','')
        },
        selling_plan: window.hasSubscription == undefined || window.hasSubscription == false ? null : window.selected_variant.selling_plan_allocations[window.selling_plan_index].selling_plan_id
      }];
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      })
        .then(response => {
          return response.json();
        })
        .then(res => {
          if (res.status == 422) {
            alert(res.message)
          }
          window.location.href = url
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }

  const fixedContent = () => {
    const left = $('.bundle-cover .option-select')
    const right = $('.bundle-cover .choose-bundle')

    let scroll = 0
    window.addEventListener('scroll', () => {
      if (window.scrollY >= scroll) {
        left.removeClass('with-header')
        right.removeClass('with-header')
      } else {
        left.addClass('with-header')
        right.addClass('with-header')
      }

      scroll = window.scrollY
    })
  }

  addToCart()
  randomPacks()
  pickMore()
  selectCover()
  spilePromoBundle()
  movePack()
  summary()
  addBundle()
  selectMulti()
  fixedContent()
}

$(document).ready(function () {
  buildBundle()
})
